import type { Database } from "@/lib/supabase";
import { ContactListItem } from "./ContactListItem";

type AccountContact = Database['public']['Tables']['account_contacts']['Row']

interface ContactListProps {
  contacts: AccountContact[];
  selectedContact: AccountContact | null;
  onContactSelect: (contact: AccountContact) => void;
  loading: boolean;
  searchTerm?: string;
}

export const ContactList = ({ contacts, selectedContact, onContactSelect, loading, searchTerm }: ContactListProps) => {
  if (loading) {
    return (
      <div className="flex-1 overflow-y-auto rounded-xl border border-[#3F3F464D] p-4">
        <div className="flex flex-col gap-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="flex items-center gap-3 animate-pulse">
              <div className="w-10 h-10 bg-neutral-600 rounded-full"></div>
              <div className="flex-1">
                <div className="h-4 bg-neutral-600 rounded mb-2"></div>
                <div className="h-3 bg-neutral-600 rounded w-3/4"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (contacts.length === 0) {
    return (
      <div className="flex-1 overflow-y-auto rounded-xl border border-[#3F3F464D] p-4">
      </div>
    );
  }

  return (
    <div className="flex-1 overflow-y-auto rounded-xl border border-[#3F3F464D] hidden md:block">
      {contacts.map((contact) => (
        <ContactListItem
          key={contact.id}
          contact={contact}
          isSelected={selectedContact?.id === contact.id}
          onSelect={() => onContactSelect(contact)}
        />
      ))}
    </div>
  );
};